import backofficeService from '../../api/backoffice'

export default {

  getCommentByID(params) {
    return backofficeService.Api().get('crm/api/comment/byID', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getCommentReply(id) {
    return backofficeService.Api().get(`crm/api/comment/reply/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getActivityByID(params) {
    return backofficeService.Api().get('api/activity/byID', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  create(data) {
    return backofficeService.Api().post('crm/api/comment', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getByTask(params) {
    return backofficeService.Api().get(`crm/api/comment/byTask`, { params })
    .then( response => response.data) 
    .catch(error => { throw error})
  }
}
